
<!--
  ~ VNCmail : A whole new experience in enterprise email communication.
  ~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published by
  ~ the Free Software Foundation, version 3 of the License.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program. Look for COPYING file in the top folder.
  ~ If not, see http://www.gnu.org/licenses/.
  -->

<div class="mail-dialog">
    <div class="mail__dialog-header desktop_view">
        <div class="header_lbl disable-select">
            {{ 'ATTACH_CONTACT_LBL' | translate }}
        </div>
        <div class="submit">
            <button mat-button (click)="close()">
                <mat-icon class="disable-select">close</mat-icon>
            </button>
        </div>
    </div>
    <div class="mail__dialog-body mail__dialog-body--pad">
        <div class="content">
            <div class="contact-loading-spinner" *ngIf="isLoading">
                <vp-custom-spinner></vp-custom-spinner>
            </div>
            <div class="search_div">
                <div class="searchField">
                    <mat-form-field>
                        <input matInput placeholder="{{'SEARCH_DOT' | translate }}" [(ngModel)]="searchField">
                    </mat-form-field>
                    <mat-icon (click)="searchContacts()">search</mat-icon>
                </div>
                <div class="pagging">
                    <button mat-button (click)="loadPreviousContact()" [disabled]="offset===0">
                        <mat-icon class="disable-select">keyboard_arrow_left</mat-icon>
                    </button>
                    <span *ngIf="limit !== 0">{{offset + 1 }} - {{limit + offset}}</span>
                    <button mat-button (click)="loadNextContact()" [disabled]="!isMoreContact">
                        <mat-icon class="disable-select">keyboard_arrow_right</mat-icon>
                    </button>
                </div>
            </div>
            <div class="tree_email_div">
                <div class="tree_div">
                    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="folder-tree">
                        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                            <li class="mat-tree-node" (click)="folderItem(node)"
                                [class.selected-class]="!!selectedFolder && selectedFolder !== null && node.id === selectedFolder.id">
                                <button mat-icon-button disabled></button>
                                <mat-icon [style.color]="node.rgb" *ngIf="node.id !==''">folder</mat-icon>
                                <span *ngIf="node.id === '7'">{{ 'CONTACTS_TITLE' | translate }}</span>
                                <span *ngIf="node.id === '13'">{{ 'EMAILED_CONTACTS_TITLE' | translate }}</span>
                                <span *ngIf="node.id !== '7' && node.id !== '13'">{{mailService?.getFolderNameKey(node.name, MailConstants?.SYSTEM_FOLDERS)}}</span>
                            </li>
                        </mat-tree-node>
                        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                            <li>
                                <div class="mat-tree-node" (click)="folderItem(node)"
                                    [class.selected-class]="!!selectedFolder && selectedFolder !== null && node.id === selectedFolder.id">
                                    <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
                                        <mat-icon class="mat-icon-rtl-mirror">
                                            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                                        </mat-icon>
                                    </button>
                                    <mat-icon [style.color]="node.rgb" *ngIf="node.id !==''">folder</mat-icon>
                                    <span *ngIf="node.id === '7'">{{ 'CONTACTS_TITLE' | translate }}</span>
                                    <span *ngIf="node.id === '13'">{{ 'EMAILED_CONTACTS_TITLE' | translate }}</span>
                                    <span *ngIf="node.id !== '7' && node.id !== '13'">{{mailService?.getFolderNameKey(node.name, MailConstants?.SYSTEM_FOLDERS)}}</span>
                                </div>
                                <ul [class.folder-tree-invisible]="!treeControl.isExpanded(node)">
                                    <ng-container matTreeNodeOutlet></ng-container>
                                </ul>
                            </li>
                        </mat-nested-tree-node>
                    </mat-tree>
                </div>
                <div class="email_list">
                    <div *ngIf="contacts.length === 0" class="no-contact-found">
                        <span>{{ 'NO_CONTACTS_FOUND_MSG' | translate }}</span>
                    </div>
                    <div *ngIf="contacts.length > 0">
                        <div *ngFor="let contact of contacts; index as i;">
                            <div class="suggestion" (click)="selectContact(contact, i, $event)"
                                [ngClass]="{'is-selected': isSelectedEmailContacts(contact)}">
                                <vp-avatar [type]="'mail-detail-avatar'"
                                    [user]="{firstLastCharacters: contact.firstLastCharacter, color: '#317bbc', email: contact.email}">
                                </vp-avatar>
                                <div class="email_name_division">
                                    <div class="disable-select subject_date">
                                        <div class="subject">
                                            {{contact.fullName}}
                                        </div>
                                    </div>
                                    <p class="disable-select">{{contact.email}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="btn">
        <button mat-button (click)="close()">
            {{ 'CANCEL' | translate }}
        </button>
        <button mat-button [disabled]="selectedContacts.length === 0" (click)="attachContacts();">
            {{ 'ATTACH_LBL' | translate }}
        </button>
    </div>
</div>